module.exports = __webpack_public_path__ + "img/placeholder-1.af50cd76.png";